<template>
    <teleport to="body">
        <Transition>
            <div v-show="actFastModalIsVisible" class="uk-text-center the-modal">
                <div class="the-modal-content the-modal-content-header uk-position-relative">
                    <div class="close-the-modal uk-position-absolute uk-position-small uk-position-top-right" @click="closeModal">
                        <BaseIcon color="#cdcdcd" height="35" stroke-width=".75" width="35">
                            <IconX />
                        </BaseIcon>
                    </div>
                </div>
                <div class="the-modal-content uk-text-center" style="width: 405px; height: 270px;">
                    <img :src="imagePath" alt="Act Fast Promotion 2 Free Chairs" width="608">
                </div>
                <div class="the-modal-content the-modal-content-body">
                    <p class="uk-h4 uk-margin-remove">{{ title }}</p>
                    <p class="uk-text-small uk-margin-remove-top">{{ description }}</p>
                    <form class="uk-form-stacked uk-text-left" novalidate @submit.prevent="submit">
                        <div class="uk-margin">
                            <label for="email">Email<span class="uk-text-danger"> *</span></label>
                            <input id="email" v-model="form.email" class="uk-input uk-form-small" name="email" type="text">
                            <span v-if="errors?.email" class="uk-text-small uk-text-danger">{{ errors.email[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <label for="zip">Zip<span class="uk-text-danger"> *</span></label>
                            <input id="zip" v-model="form.zip" class="uk-input uk-form-small" name="zip" type="text">
                            <span v-if="errors?.zip" class="uk-text-small uk-text-danger">{{ errors.zip[0] }}</span>
                        </div>
                        <div class="uk-flex uk-flex-right">
                            <button class="uk-button uk-button-primary">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </Transition>
    </teleport>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue"
import BaseIcon from "../ui/BaseIcon.vue"
import IconX from "../icons/IconX.vue"
import {storeToRefs} from "pinia";
import {useWishlistStore} from "../../stores/WishlistStore";
import {useModalStatusStore} from "../../stores/ModalStatusStore";

const modalStatusStore = useModalStatusStore()
const {setWishlistDataFromServer} = useWishlistStore()
const errors = ref({})

const form = reactive({
    email: '',
    zip: ''
});

const props = defineProps({
    title: String,
    description: String,
    image: String
})

const imagePath = computed(() => {
    return '/imagecache/promos/608/a/a/' + props.image
})

const {
    actFastModalIsVisible,
    actFastModalClosedByHuman
} = storeToRefs(modalStatusStore)

onMounted(() => {
    if (false === actFastModalClosedByHuman.value) {
        setTimeout(function () {
            modalStatusStore.showActFastModal()
        }, 5000);
    }
})

function closeModal() {
    modalStatusStore.hideActFastModalByHuman()

    window.location.reload()
}

async function submit() {
    try {
        let r = await axios
            .post('/lead/store', form)

        setWishlistDataFromServer(r.data.data)

        closeModal()
    } catch (error) {
        if (error.response.status === 422) {
            errors.value = error.response.data.data.errors
        }
        // DEBUG OUT
        //Utility.catchError(error)
    }
}
</script>

<style scoped>
.the-modal {
    position: fixed; /* Stay in place */
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.8); /* w/ opacity */
}

/* Modal Content/Box */
.the-modal-content {
    background-color: #ffffff;
    margin-left: auto;
    margin-right: auto;
}

.the-modal-content-header {
    max-width: 403px;
    margin-top: 20px;
}

.the-modal-content-body {
    margin-top: 0;
    margin-bottom: 0;
    padding: 20px 30px 30px 30px;
    max-width: 345px;
}

.close-the-modal {
    cursor: pointer;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.75s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
